import { gql, QueryHookOptions, useQuery } from '@apollo/client';
import { User } from '../../dto';

type Variables = { userId: number };
type Results = {
  user: {
    roadmapMilestones: User['roadmapMilestones'];
  }
};

export const useRoadmapMilestones = (options?: QueryHookOptions<Results, Variables>) => {
  const query = gql`
    query getRoadmapMilestones($userId: Int!) {
      user(id: $userId) {
        roadmapMilestones {
          id
          required
          allowMultipleInstances
          isUserNameable
          tasks {
            id
            name {
              id
              text
            }
            actionType
          }
        }
      }
    }
  `;

  return useQuery(query, options);
};

export default useRoadmapMilestones;
